import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import mediaQueries from 'app/utils/mediaQueries';
import { getFacetIds } from './availableFacetsReducer';
import { getAllAppliedFacetItemUids } from '../../productsReducer';
import './product-list_facets.scss';
import FacetsListMediumDown from './facetsListMediumDown';

class FacetsListHOC extends Component {
  constructor() {
    super();

    this.state = {
      isMediumDown: mediaQueries.is_medium_down(),
    };
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      const { isMediumDown } = this.state;
      const isMediumDownCurrent = mediaQueries.is_medium_down();
      if (isMediumDown !== isMediumDownCurrent) {
        this.setState({
          isMediumDown: isMediumDownCurrent,
        });
      }
    });
  }

  render() {
    const { isMediumDown } = this.state;
    const { facetIds, appliedItemsCount, isFetching, numberOfProducts } = this.props;

    return (
      !!numberOfProducts &&
      isMediumDown && (
        <FacetsListMediumDown
          facetIds={facetIds}
          appliedItemsCount={appliedItemsCount}
          isFetching={isFetching}
          numberOfProducts={numberOfProducts}
        />
      )
    );
  }
}

FacetsListHOC.propTypes = {
  facetIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  appliedItemsCount: PropTypes.number.isRequired,
  isFetching: PropTypes.bool.isRequired,
  numberOfProducts: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  facetIds: getFacetIds(state.filters.available),
  appliedItemsCount: getAllAppliedFacetItemUids(state).length,
  numberOfProducts: state.products.totalItems,
  isFetching: state.isFetching,
});

export default connect(mapStateToProps)(FacetsListHOC);
